// src/routes/admin.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { AdminHome, AdminTournoi, AdminClub, AdminEpreuve, AdminLigue, AdminCategorie } from '../pages/admin';


const adminRoutes: RouteObject[] = [
    {
        path: '/admin',
        children: [
            { 
                index: true, 
                element: React.createElement(AdminHome)
            },
            { 
                path: 'tournoi', 
                element: React.createElement(AdminTournoi)
            },
            { 
                path: 'club', 
                element: React.createElement(AdminClub)
            },
            { 
                path: 'ligue', 
                element: React.createElement(AdminLigue)
            },
            { 
                path: 'epreuve', 
                element: React.createElement(AdminEpreuve)
            },
            { 
                path: 'categorie', 
                element: React.createElement(AdminCategorie)
            }
        ]
    }
];

export default adminRoutes;